import { Box, Skeleton, Stack } from '@mui/material'
import React from 'react'

const DesktopFlightCardShimmer: React.FC = () => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            bgcolor: 'white',
            borderRadius: 1,
            py: 1.5,
            px: 3,
            mb: 2,
            boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
            minHeight: 112,
            gap: 2
        }}
    >
        {/* Airline logo */}
        <Box width={100} alignItems="center" display="flex" flexDirection="column">
            <Skeleton variant="rectangular" width={48} height={48} sx={{ borderRadius: 1, mr: 2 }} />
            <Skeleton variant="text" width={40} height={20} sx={{ borderRadius: 1, mr: 2 }} />
        </Box>

        {/* Flight details */}
        <Box sx={{ flex: 1 }}>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: 1, mb: 1 }}>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Skeleton variant="text" width={50} height={30} sx={{ borderRadius: 0.5 }} />
                    <Skeleton variant="text" width={40} height={20} sx={{ borderRadius: 0.5 }} />
                </Box>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Skeleton variant="text" width={40} height={20} sx={{ borderRadius: 0.5 }} />
                    <Skeleton variant="text" width={132} height={10} sx={{ borderRadius: 0.5 }} />
                    <Skeleton variant="text" width={50} height={20} sx={{ borderRadius: 0.5 }} />
                </Box>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Skeleton variant="text" width={50} height={30} sx={{ borderRadius: 0.5 }} />
                    <Skeleton variant="text" width={40} height={20} sx={{ borderRadius: 0.5 }} />
                </Box>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Box></Box>
                {/* <Skeleton variant="rectangular" width={24} height={6} />
                <Skeleton variant="text" width={52} height={18} />
                <Skeleton variant="text" width={40} height={16} />
                <Skeleton variant="rounded" width={60} height={20} /> */}
            </Stack>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Price */}
            <Box sx={{ alignItems: 'flex-end', minWidth: 90, textAlign: 'right' }}>
                <Skeleton variant="text" width={60} height={28} sx={{ mb: 1 }} /> {/* Price */}
            </Box>
            {/* Book Now button */}
            <Box>
                <Skeleton variant="rectangular" width={96} height={36} sx={{ borderRadius: 1, mb: 1 }} />
                <Skeleton variant="text" width={90} height={20} />
            </Box>
        </Box>
    </Box>
)

export default DesktopFlightCardShimmer
